import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import ContentSections from './components/ContentSections';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const siteUrl = (import.meta.env as Record<string, string>).VITE_SITE_URL || 'https://basetaosheet.monster';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'BaseTao Spreadsheet Hub',
  url: siteUrl,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/0dc5bc4081b05862da3d01553c9c9d93.png',
  description: 'The most comprehensive English resource hub for BaseTao Spreadsheet guides, reviews, shipping cost analysis, warehouse tips, discount tracking, and expert comparisons.',
  sameAs: ['https://kaspreadsheet.com'],
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'BaseTao Spreadsheet — Complete Research Database, Review Guide & Shopping Resource',
  description: 'Discover comprehensive BaseTao Spreadsheet guides, product research tools, shipping cost analysis, warehouse tips, discount tracking, and expert comparisons.',
  url: siteUrl,
  isPartOf: {
    '@type': 'WebSite',
    name: 'BaseTao Spreadsheet Hub',
    url: siteUrl,
  },
  about: {
    '@type': 'Thing',
    name: 'BaseTao Spreadsheet',
    description: 'A comprehensive research database and organizational tool for shoppers to track, compare, and analyze products across multiple categories.',
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: siteUrl,
      },
    ],
  },
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <ContentSections />
        <FAQ />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}